// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"42":"2fd0654b","596":"f6a4fc84"}[chunkId] + ".css";
};